export const requiredMessage = 'This is required field';
export const positiveNumberMessage = 'Must be positive number';
export const numberTypeMessage = 'Must be a number';
export const integerMessage = 'Must be a whole number';
export const phoneMessage = 'Must contain a valid phone number';
export const phoneLocalOnlyMessage = 'Must contain a valid 10 or 11-digit UK phone number';
export const alphaMessage = 'Special characters and digits are not allowed';
export const alphaNumMessage = 'Special characters are not allowed';

